import { render, staticRenderFns } from "./EditSalePricesConsignorPrice.vue?vue&type=template&id=67fd0045&scoped=true"
import script from "./EditSalePricesConsignorPrice.vue?vue&type=script&lang=js"
export * from "./EditSalePricesConsignorPrice.vue?vue&type=script&lang=js"
import style0 from "./EditSalePricesConsignorPrice.vue?vue&type=style&index=0&id=67fd0045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd0045",
  null
  
)

export default component.exports